/* eslint-disable import/prefer-default-export */

import {
  getAprooverFilters,
  getInspectorFilters
} from '../../components/WeeklyReportTable/utils/consts';
import { isoFromDate, todayIso } from '../../components/WeeklyReportTable/utils/date';
import { getSavedFilters } from '../../services/userFilterServices';
import { ubicationTypeEnum } from '../../utils/dataStatus';
import { formatFilterToComboOption } from '../../utils/formatUtils';

/**
 * @param {import('../../components/WeeklyReportTable/hooks/useFilters').Filters} filters
 * @returns {import('../../services/workReport').WeeklyReportFilters}
 */
export const filtersAdapter = (filters, isInspector) => {
  let unidadesNegocio = [];

  if (filters?.tipoUbicacionId?.id) {
    const isOyM =
      filters?.tipoUbicacionId?.id !== ubicationTypeEnum.pozo &&
      filters?.tipoUbicacionId?.id !== ubicationTypeEnum.locacion;

    unidadesNegocio = isOyM ? filters.operacionesIds : filters.unidadesNegocioIds;
  }
  const adapter = {
    contratosIds: filters.contratosIds?.map((contract) => contract.id),
    partesVisualizar: filters.partesVisualizar,
    equiposIds: filters.idsEquipos?.map((equipment) => equipment.value),
    eventosIds: filters.idsEventos?.map((event) => event.value),
    proveedoresIds: filters.idsProveedores?.map((provider) => provider.id),
    posicionesLineas: filters.posicionesLineas?.map((positionLine) => positionLine?.value),
    serviciosIds: filters.serviciosIds?.map((service) => service.id),
    tipoUbicacionId: filters.tipoUbicacionId?.id || null,
    ubicacionesIds: filters.ubicacionesIds?.map((location) => location?.nombre),
    unidadesNegocio: unidadesNegocio?.map((unidad) => unidad?.id) || [],
    numerosSolicitudes: filters.numerosSolicitudes?.map((request) => request),
    ...(!isInspector && {
      estadosSolicitud: filters.estadosSolicitud?.map((request) => request?.id) || []
    }),
    ...(isInspector && {
      eventosPozosIds: filters.eventosPozosIds?.map((event) => event?.id),
      estadoSolicitud: filters.estadoSolicitud?.id || null,
      centrosLogisticos: filters.centrosLogisticos?.map((center) => center?.nombre),
      tipoImputacion: filters.tipoImputacion?.id || null,
      objetosImputacionesIds: filters.objetosImputacionesIds?.map((obj) => obj?.id)
    }),
    desde: filters?.fechaDesde,
    hasta: filters?.fechaHasta,
    ...(isInspector
      ? { grupoEstadoParteId: filters.estadoParteId?.id || null }
      : { estadoParteId: filters.estadoParteId?.id || null })
  };

  return adapter;
};

export const filtersAdapterToSave = (filters, isInspector) => {
  const getNameAndId = (filter) => ({
    id: filter.id,
    nombre: filter.nombre
  });

  const partStateIdName = isInspector ? 'grupoEstadoParteId' : 'estadoParteId';
  let unidadesNegocio = [];

  if (filters?.tipoUbicacionId?.id) {
    const isOyM =
      filters?.tipoUbicacionId?.id !== ubicationTypeEnum.pozo &&
      filters?.tipoUbicacionId?.id !== ubicationTypeEnum.locacion;

    unidadesNegocio = isOyM ? filters.operacionesIds : filters.unidadesNegocioIds;
  }

  return {
    TipoFiltroUsuario: isInspector ? getInspectorFilters : getAprooverFilters,
    filtros: JSON.stringify({
      contratosIds: filters.contratosIds?.map((contract) => getNameAndId(contract)),
      partesVisualizar: filters.partesVisualizar,
      equiposIds: filters.idsEquipos?.map((equipment) => getNameAndId(equipment)),
      eventosIds: filters.idsEventos?.map((event) => getNameAndId(event)),
      proveedoresIds: filters.idsProveedores?.map((provider) => getNameAndId(provider)),
      posicionesLineas: filters.posicionesLineas?.map((positionLine) => positionLine?.value),
      serviciosIds: filters.serviciosIds?.map((service) => getNameAndId(service)),
      tipoUbicacionId: filters.tipoUbicacionId
        ? { nombre: filters.tipoUbicacionId.nombre, id: filters.tipoUbicacionId.id }
        : null,
      ubicacionesIds: filters.ubicacionesIds?.map((location) => getNameAndId(location)),
      [partStateIdName]: filters.estadoParteId
        ? { nombre: filters.estadoParteId.nombre, id: filters.estadoParteId.id }
        : null,
      fechaDesde: filters?.fechaDesde,
      fechaHasta: filters?.fechaHasta,
      unidadesNegocio: unidadesNegocio?.map((unidad) => unidad) || [],
      numerosSolicitudes: filters.numerosSolicitudes?.map((request) => request),
      ...(!isInspector && {
        estadosSolicitud: filters.estadosSolicitud?.map((request) => request) || []
      }),
      ...(isInspector && {
        eventosPozosIds: filters.eventosPozosIds?.map((event) => event),
        estadoSolicitud: filters.estadoSolicitud || null,
        centrosLogisticos: filters.centrosLogisticos?.map((center) => center),
        tipoImputacion: filters.tipoImputacion || null,
        objetosImputacionesIds: filters.objetosImputacionesIds?.map((obj) => obj)
      })
    })
  };
};

const mapInspectorFilters = (isInspector, savedFilters) => {
  if (isInspector) {
    return {
      numerosSolicitudes: savedFilters.numerosSolicitudes?.map((request) => request),
      eventosPozosIds: savedFilters.eventosPozosIds?.map((event) => event),
      estadoSolicitud: savedFilters.estadoSolicitud || null,
      centrosLogisticos: savedFilters.centrosLogisticos?.map((center) => center),
      tipoImputacion: savedFilters.tipoImputacion || null,
      objetosImputacionesIds: savedFilters.objetosImputacionesIds?.map((obj) => obj)
    };
  }

  return {
    estadosSolicitud: savedFilters.estadosSolicitud?.map((request) => request) || []
  };
};

export const getSavedFiltersAdapter = async (isInspector) => {
  try {
    const userType = isInspector ? getInspectorFilters : getAprooverFilters;

    const { filtros } = await getSavedFilters(userType);
    const savedFilters = JSON.parse(filtros);

    return {
      contratosIds: formatFilterToComboOption(savedFilters.contratosIds) || [],
      partesVisualizar: savedFilters.partesVisualizar,
      idsEquipos: formatFilterToComboOption(savedFilters.equiposIds) || [],
      idsEventos: formatFilterToComboOption(savedFilters.eventosIds) || [],
      idsProveedores: formatFilterToComboOption(savedFilters.proveedoresIds) || [],
      posicionesLineas: savedFilters.posicionesLineas.map((e) => {
        const [position, line] = e.split('-');

        return {
          label: `P${position} - L${line}`,
          value: e
        };
      }),
      tipoUbicacionId: formatFilterToComboOption(savedFilters.tipoUbicacionId) || null,
      ubicacionesIds: formatFilterToComboOption(savedFilters.ubicacionesIds) || [],
      serviciosIds: formatFilterToComboOption(savedFilters.serviciosIds) || [],
      estadoParteId:
        formatFilterToComboOption(
          isInspector ? savedFilters.grupoEstadoParteId : savedFilters.estadoParteId
        ) || null,
      fechaDesde: savedFilters.fechaDesde || isoFromDate,
      fechaHasta: savedFilters.fechaHasta || todayIso,
      unidadesNegocio: formatFilterToComboOption(savedFilters.unidadesNegocio) || [],
      numerosSolicitudes: savedFilters.numerosSolicitudes?.map((request) => request),
      ...mapInspectorFilters(isInspector, savedFilters)
    };
  } catch {
    return null;
  }
};
